import {
  Button,
  Modal,
  notification,
  Popconfirm,
  Space,
  Typography,
} from "antd";
import Dragger from "antd/lib/upload/Dragger";
import { useHistory } from "react-router-dom";
import { ReactComponent as AddFileGray } from "../../../../assets/images/upload-file-gray.svg";
import { useState } from "react";
import API_SERVICE from "shared/services/api-service";
import { ReactComponent as Information } from "../../../../assets/images/information.svg";
import deletefile from "../../../../../src/assets/images/delete.svg";
import { RootState } from "shared/redux/store";
import { useSelector } from "react-redux";

const { Text } = Typography;

const BulkUpdateStartImport: React.FunctionComponent<{
  setActiveStepKey: any;
  setFileName: any;
}> = (props) => {
  const history = useHistory();
  const [uploadFile, setUploadFile] = useState({} as any);
  const [isopenStart, setIsopenStart] = useState(true);
  const [allowedAttechmentTypes] = useState([
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ]);
  const { setActiveStepKey } = props;
  const filePlaceholder = "Drag or Drop your file here";
  const [selectedFileName, setSelectedFileName] = useState(filePlaceholder);
  const { setFileName } = props;
  const [isRemove, setIsRemove] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isUserGuideModalOpen, setIsUserGuideModalOpen] = useState(false);
  const { appColors }: any = useSelector((state: RootState) => state.common);

  const onBulkUploadChange = (file: any) => {
    if (isRemove) {
      setIsRemove(false);
    }
    setUploadFile(file);
    setSelectedFileName(file?.file?.name);
  };

  const goToUploadImportBulkUpload = () => {
    if (isRemove || !uploadFile.file?.name) {
      notification.error({ message: "Please select file" });
      return;
    }

    if (allowedAttechmentTypes.indexOf(uploadFile.file.type) === -1) {
      notification.error({ message: "Please attach only .xlsx file." });
      return;
    }

    let formData = new FormData();
    formData.append("file", uploadFile.file);
    setLoading(true);
    const entityType = "BULK_LEAD_LOGIN";
    API_SERVICE.bulkUploadStart(entityType, formData)
      .then(({ data }) => {
        if (data) {
          localStorage.setItem("uploadId", data.payload.uploadId);
          setIsopenStart(false);
          setActiveStepKey(1);
          setFileName(selectedFileName);
        }
      })
      .catch((e: any) => {
        notification.error({ message: API_SERVICE.handleErrors(e) });
      })
      .finally(() => setLoading(false));
  };

  const onFileRemove = () => {
    setSelectedFileName(filePlaceholder);
    if (!isRemove) {
      setIsRemove(true);
    }
  };

  const onClickUserGuide = () => {
    setIsUserGuideModalOpen(true);
  };

  const onOkUserGuideModal = () => {
    setIsUserGuideModalOpen(false);
  };

  const onCancelUserGuideModal = () => {
    setIsUserGuideModalOpen(false);
  };

  const onDeleteDoc = () => {
    setSelectedFileName(filePlaceholder);
    if (!isRemove) {
      setIsRemove(true);
    }
  };

  const customStylesBtn: any = {
    "--borderColor": appColors?.appSecondaryColor ?? "",
    marginLeft: "10px",
  };
  const customStylesBtnPrimary: any = {
    "--btnColor": appColors?.appPrimaryColor ?? "",
    marginRight: "10px",
  };
 
  const renderUserGuide = () => {
    return (
      <Modal
        footer={false}
        width={700}
        title="Note"
        visible={isUserGuideModalOpen}
        onOk={onOkUserGuideModal}
        onCancel={onCancelUserGuideModal}
      >
        <div style={{ fontWeight: "bold" }}>
        You can use this feature to login bulk leads to lenders in Oneflo. Please ensure the below while 
        creating leads in bulk
        </div>
        <div style={{ fontWeight: "300", marginTop:"10px" }}>
          1. Always select the leads, export them and use the same file for Bulk login
        </div>
        <div style={{ fontWeight: "300",marginTop:"10px" }}>
          2. Ensure that the mandatory fields(*) are filled in for all rows wrt loan product and Applicant Sub Type
        </div>
        <div style={{ fontWeight: "300",marginTop:"10px" }}>
          3. Use only the values available in the drop-down form fields where the drop-down is available on the excel 
          template (Ex: M,F,O)
        </div>
        <div style={{ fontWeight: "300",marginTop:"10px" }}>
          4. Field Mappings and Validations:
            <ul>
              <li style={{ fontWeight: "300",marginTop:"10px" }}>Applicant Type and Applicant Sub Type should be correctly mapped:</li>
              <ul>
                <li style={{ fontWeight: "300",marginTop:"10px" }}>
                    Applicant Type Individual can only match with Applicant Sub Type 'SALARIED' or 'SELF_EMPLOYED'.
                </li>
                <li style={{ fontWeight: "300",marginTop:"10px" }}>
                  Applicant Type Business cannot match with Applicant Sub Type 'SALARIED' or 'SELF_EMPLOYED'.
                </li>
              </ul>
            </ul> 
        </div>
        <div style={{ fontWeight: "300",marginTop:"10px", marginBottom:'20px' }}>
          5. The optional fields can be included in the upload for better data tracking'
        </div>
      </Modal>
    );
  };

  return (
    <>
      {isopenStart && (
        <div>
          <div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Text>
                <h4>Bulk Login Of Leads</h4>
              </Text>
            </div>
            <div style={{ display: "flex", justifyContent: "center", fontSize:"16px", fontWeight:"normal" }}>
                Note: If there was an eligibility run then decisioning
            </div>
            <div style={{ display: "flex", justifyContent: "center", fontSize:"16px", fontWeight:"normal" }}>
               will be reset after the upload of excel.
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "20px",
                height: "200px",
              }}
            >
              <Dragger
                style={{
                  width: "600px",
                  height: "400px",
                  borderRadius: "20px",
                }}
                accept=".xlsx,"
                name="bulkUpload"
                maxCount={1}
                beforeUpload={() => {
                  return false;
                }}
                onChange={onBulkUploadChange}
                onRemove={onFileRemove}
                showUploadList={false}
              >
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      margin: "10px",
                    }}
                  >
                    <Space className=" start-import-upload-icon ">
                      <AddFileGray width={60} height={60} />
                    </Space>
                  </div>
                  <div>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <Text>
                        {isRemove
                          ? "Drag or Drop your file here"
                          : selectedFileName}
                      </Text>
                    </div>
                  </div>
                </div>
              </Dragger>
              <div
                style={{
                  border: "none",
                  marginLeft: "-35px",
                  marginTop: "25px",
                  zIndex: "1",
                }}
              >
                <img src={deletefile} onClick={onDeleteDoc} alt="" width={20} />
              </div>
            </div>
          </div>

          <div>
            <p
              className="bulk-uplopad-span"
              style={{ "--bgColor": appColors?.appSecondaryColor ?? "" } as any}
            >
              <Information
                style={
                  {
                    "--bgColor": appColors?.appSecondaryColor ?? "",
                    width: "30px",
                  } as any
                }
              />
              <span style={{ cursor: "pointer" }} onClick={onClickUserGuide}>
                {" "}
                User Guide - How to Bulk Login
              </span>
            </p>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "40px",
            }}
          >
            <Button
              className="bulk-upload-btn  dynamic-btn-primary"
              style={customStylesBtnPrimary}
              type="primary"
              loading={loading}
              onClick={() => goToUploadImportBulkUpload()}
            >
              Next
            </Button>
            <Popconfirm
              title="Your uploaded file will be deleted"
              className="popconfirm"
              onConfirm={(event) => history.goBack()}
              okButtonProps={{
                style: {
                  backgroundColor: appColors?.appPrimaryColor ?? "#273896",
                  border: "none",
                },
              }}
              cancelButtonProps={{
                style: {
                  borderColor: appColors?.appSecondaryColor ?? "#C71C8E",
                  color: appColors?.appSecondaryColor ?? "#C71C8E",
                },
              }}
            >
              <Button
                className="bulk-upload-btn  dynamic-btn-default"
                style={customStylesBtn}
                // onClick={() => { history.goBack() }}
              >
                Back
              </Button>
            </Popconfirm>
          </div>
        </div>
      )}
      {renderUserGuide()}
    </>
  );
};

export default BulkUpdateStartImport;
